import { Component, ViewChild, ViewEncapsulation, Input, Output, EventEmitter } from '@angular/core';
import { Subscription } from 'rxjs';
import { PageChangeEvent, RowArgs } from '@progress/kendo-angular-grid';
import { DispatchesService } from '@app/cp/shared/services/dispatches.service';
import { v_DispatchBus } from '@app/cp/shared/models/v_DispatchBus';
import { GlobalsService } from '@app/cp/shared/services/globals.service';
import { BaseGridComponent } from '@app/cp/shared/base-components/base-grid.component';
import { WidgetSearch } from '@app/cp/shared/models/WidgetSearch';
import * as _ from 'lodash';
import { DashboardService } from '@app/cp/shared/services/dashboard.service';
import { TooltipDirective } from '@progress/kendo-angular-tooltip';
import { DashboardWidgetService } from '@app/cp/shared/services/dashboardWidget.service';
import { WindowContents } from '@app/cp/shared/enums/windowContents';
import { CompositeFilterDescriptor, filterBy, orderBy, SortDescriptor } from '@progress/kendo-data-query';
import { FeatureFlagService } from "@app/cp/shared/services/feature-flag.service";
import { UseFeatureFlagSet, IFeatureFlagSet } from '@app/cp/shared/decorators/featureflags/featureflagset-decorator';
import { ConfirmDialogComponent, ConfirmDialogOptions } from '../../../components/confirm-dialog/confirm-dialog.component';
import { CPDialogResult } from '../../../enums/CPDialogResult';
import { ConfirmOutput } from '../../../models/ConfirmOutput';
import { CommonValues } from '../../../static/CommonValues';
import { DispatchQVSettingsInput } from '../../../models/DispatchQVSettingsInput';
import { DQOIDisplaySettings } from '../../../models/DQOIDisplaySettings';
import { popoutService } from '@app/cp/shared/services/popout.service';


@UseFeatureFlagSet()
@Component({
    selector: 'cp-zuggit-cp-dispatch-needs-parts-grid',
    templateUrl: './zuggit-cp-dispatch-needs-parts-grid.component.html',
    styleUrls: ['./zuggit-cp-dispatch-needs-parts-grid.component.scss'],
    standalone: false
})
export class ZuggitCpDispatchNeedsPartsGridComponent extends BaseGridComponent<v_DispatchBus, null>  {

    compFeatureFlagSet: IFeatureFlagSet = this as any;

    lastMessage: unknown;
    private popoutSub?: Subscription;

    searchParam: WidgetSearch;
    subscriptions: Subscription[] = [];
    public filter: CompositeFilterDescriptor;
    public filterChange(filter: CompositeFilterDescriptor): void {
        this.filter = filter;
        this.gridData = filterBy(this.originalGridData, filter);
        this.processGridData();
    }

    @ViewChild('cnfSalesOrderDialog') protected cnfDialog: ConfirmDialogComponent;

    constructor(globals: GlobalsService, featureFlagService: FeatureFlagService, private svc_data: DispatchesService, private svc_dashWidget: DashboardWidgetService, private svc_dashboard: DashboardService, public popout: popoutService) {
        super(globals, featureFlagService);
        this.allData = this.allData.bind(this);
        this.subscriptions.push(svc_dashboard.generalWidgetRefresh$.subscribe(
            refresh => {
                this.loaderState = true;
                this.getData();
            }));
        this.popout.register('ZuggitCpDispatchNeedsPartsGridComponent');
        this.subscriptions.push(popout.dashBoardMessages$().subscribe(msg => {
            this.lastMessage = msg.data;
            if (this.lastMessage['action'] && this.lastMessage['action'] === 'openSalesOrder') {
                this.getData();
                this.showDetailsPopup(this.lastMessage['salesOrderId'], 1, false, false);
                this.popout.openOrReuse('/popout/service/1/' + this.lastMessage['dispatchId']);
            }
        }));
        
    }

    @Input() inputData: any;
    @Input() dataFilter: WidgetSearch;
    @Input() changeCheck: string;
    @Output() openRequest = new EventEmitter<any>();
    loaderState: boolean = true;
    public activeChildComp: number;
    public windowData: any = {};
    public showDetails: boolean = false;
    public contentTypes = WindowContents;

    exportFilteredData: any[];

    initialLoad: boolean = true;

    ngOnInit() {
        //this.titleChild.emit(null); //('Open Dispatches - Detail');
        this.setup(this.dataFilter);
        this.initialLoad = false;
    }

    ngOnChanges() {
        this.loaderState = true;
        if (!this.initialLoad) {
            this.setup(this.dataFilter);
        }
    }

    override ngOnDestroy() {
        super.ngOnDestroy();
        this.subscriptions.forEach(subscription => subscription.unsubscribe());
        this.popout.unregister('ZuggitCpDispatchNeedsPartsGridComponent');
    }
    public sort: SortDescriptor[] = [{
        field: 'dispatchNumber',
        dir: 'asc'
    }];
    public sortChange(sort: SortDescriptor[]): void {
        this.sort = sort;
    }
    getData() {
        this.loaderState = true;
        this.hideError();
        this.svc_data.getCPForZuggitStatusDetailByWidgetSearch(this.searchParam).subscribe(data => {
            if (data == null || data.length == 0) {
                this.handleNetworkError(null);
            } else {
                this.data = data;

                this.originalGridData = _.cloneDeep(data);
                this.gridData = orderBy(filterBy(this.originalGridData, this.filter), this.sort);

                this.loaderState = false;
                if (this.lastIdLoaded) {
                    this.selection = [];
                    this.selection.push(this.lastIdLoaded);
                    this.state.skip = this.lastSkip;
                    this.lastIdLoaded = null;
                }

            }
        },
            error => this.handleNetworkError(error));
    }

    returnError: boolean = false;

    handleNetworkError(error) {
        this.showError();
    }

    showError() {
        this.loaderState = false;
        this.returnError = true;
    }

    hideError() {
        this.returnError = false;
    }

    public setup(data: WidgetSearch) {
        this.searchParam = data;
        this.getData();
    }

    onPopoutLinkClick(url: string) {
        this.popout.openOrReuse(url); // reuses the window; loads new URL in it
    }
    public openNewTab(linkObj: any) {
        window.open(linkObj.url, "_blank");
    }
    public pageChange(event: PageChangeEvent): void {
        this.state.skip = event.skip;
    }
    lastIdLoaded: string = null;
    lastSkip = null;
    public selection: string[] = [];
    public selectionKey(context: RowArgs): string {
        return context.dataItem.dispatchId;
    }

    showDetailsPopup(id: string, type: number, useCPRefData: boolean = false, forceReadOnly: boolean = false) {
        this.grid
        this.lastIdLoaded = id;
        this.selection = [];
        this.selection.push(this.lastIdLoaded);
        this.lastSkip = this.state.skip;
        let dqoiDisplaySettings = new DQOIDisplaySettings({ useCPRefData: useCPRefData, forceReadOnly: forceReadOnly });
        
        this.svc_dashboard.openDQOIPopup(id, type, dqoiDisplaySettings);
    }

    showCPDispatchROQVPopup(dispatch) {
        var qvSettings = new DispatchQVSettingsInput();
        qvSettings.dispatchId = dispatch.dispatchId;
        qvSettings.readOnlyMode = true;
        qvSettings.showDetails = true;
        qvSettings.dispatchHeaderButtons = false;
        qvSettings.createSalesOrderBtn = true;
        qvSettings.useCPRefData = true;
        this.lastIdLoaded = dispatch;
        this.selection = [];
        this.selection.push(this.lastIdLoaded);
        this.lastSkip = this.state.skip;
        this.svc_dashboard.openDispatchQVPopup(dispatch, qvSettings);
    }

    createZuggitSalesOrderForCPDispatch(dispatchId: string, dispatchNumber: string) {
        //alert(dispatchId + ' - ' + dispatchNumber + ' - This feature is not implemented yet.');
        const opt = new ConfirmDialogOptions();
        opt.title = "Create Sales Order from Dispatch?";
        opt.message = `Are you sure you want to create a sales order from Climate Pros dispatch: ${dispatchNumber}?`;
        opt.okButtonText = "Create Sales Order";
        opt.cancelButtonText = "Cancel";
        this.cnfDialog.showWithOverrides(opt);
    }

    confirmCreateSalesOrderDialog(data: ConfirmOutput) {
        alert(JSON.stringify(data));
        if (data.dialogResult === CPDialogResult.ok) {
            //this.svc_data.createSalesOrderFromDispatch(dispatchId);
        }
    }

    @ViewChild(TooltipDirective) public tooltipDir: TooltipDirective;

    public showTooltip(e: MouseEvent): void {
        const element = e.target as HTMLElement;
        if ((element.nodeName === 'TD' || element.nodeName === 'TH')
            && element.offsetWidth < element.scrollWidth) {
            this.tooltipDir.toggle(element);
        } else {
            this.tooltipDir.hide();
        }
    }
}